import React from 'react';
import { KeyValueMap } from '../KeyValueMap';
import { ActionType } from '../components/ActionType';
import ResponsiveToolbar from '../components/ResponsiveToolbar';
import { Icons } from '../icons/Icons';

export const listTypes: KeyValueMap<string, ActionType> = {
    bullet: {
        icon: Icons.BulletedList,
        label: 'lexical.format.bulleted.list'
    },
    number: {
        icon: Icons.FormatListNumbered,
        label: 'lexical.format.numbered.list'
    },
    check: {
        icon: Icons.Checklist,
        label: 'lexical.format.check.list'
    }
};

export default ({ isSmall, blockType, setBlockType, disabled }) => {
    return (
        <ResponsiveToolbar
            multi={false}
            disabled={disabled}
            isSmall={true}
            selected={blockType}
            onSelect={setBlockType}
            options={listTypes}
            icon={Icons.BulletedList}
        />
    );
};
